import { render, staticRenderFns } from "./EpisodeCard.vue?vue&type=template&id=113d141f&"
import script from "./EpisodeCard.vue?vue&type=script&lang=js&"
export * from "./EpisodeCard.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports